// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"5c566359","805":"2c877c72"}[chunkId] + ".chunk.js";
};